import { motion } from "framer-motion";
import Loader from "src/components/Loader";

const SPACING = 3;

type SwitchProps = {
	value: boolean;
	onChange: (v: boolean) => void;
	label?: any;
	subLabel?: any;
	type?: string;
	fetching?: boolean;
	className?: string;
};

const Switch = ({
	value,
	onChange,
	label,
	type,
	fetching,
	subLabel,
	className,
}: SwitchProps) => {
	return (
		<div className={`flex gap-2 ${className}`}>
			{fetching && <Loader />}
			<div className="flex">
				<div
					style={{ padding: SPACING }}
					onClick={() => onChange(!value)}
					className={`h-5 w-10 p-2 cursor-pointer rounded-full relative flex items-center transition-all
                        ${value ? "bg-primary justify-end" : "bg-dark"}
                    `}
				>
					<motion.div
						className="rounded-full w-[14px] pb-[14px] bg-white block"
						layout
						transition={{
							type: "spring",
							stiffness: 700,
							damping: 30,
						}}
					></motion.div>
				</div>
			</div>
			<div className="flex-1">
				{label && <p className="mb-0 leading-4">{label}</p>}
				{subLabel && (
					<small className="mb-0 opacity-40">{subLabel}</small>
				)}
			</div>
		</div>
	);
};

export default Switch;
